<!-- 新闻总页面 NewsDetail.vue -->
<template>
  <div class="news-detail-container">
    <el-card class="detail-card">
      <!-- 头部 - 添加返回按钮 -->
      <div class="detail-header">
        <div class="header-left">
          <h2>{{ belong }}</h2>
        </div>
        <div class="header-right">
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            @click="goBack"
            class="back-button"
          >
            返回
          </el-button>
        </div>
      </div>

      <!-- 问题列表 -->
      <div class="detail-list">
        <!-- 加载状态 -->
        <div v-if="isLoading" class="loading-state">
          <i class="fas fa-spinner fa-spin"></i>
          <p>加载中...</p>
        </div>
        
        <!-- 空状态 -->
        <div v-else-if="allNews.length === 0" class="empty-state">
          <i class="fas fa-inbox"></i>
          <p>暂无问题</p>
        </div>
        
        <!-- 正常列表 -->
        <el-collapse v-else v-model:activeNames="activeNames" accordion>
          <el-collapse-item
            v-for="(item, index) in allNews"
            :key="item.id"
            :name="item.id + ''"
            class="detail-accordion-item"
          >
            <template #title>
              <div class="accordion-title" @click="updateReadingVolume(item)">
                <span class="title-text">{{ item.title }}</span>
                <el-tag type="info" size="small" class="view-count-tag">
                  浏览 {{ item.readingvolume }}
                </el-tag>
                <span class="date">{{ item.date }}</span>
              </div>
            </template>
            <!-- 内容加载状态 -->
            <div v-if="!item.content" class="content-loading">
              <i class="fas fa-spinner fa-spin"></i>
              <span>加载中...</span>
            </div>
            <div v-else class="item-content" v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
          v-model:current-page="currentPage"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getNewsDetail } from "@/api/newsApi";
import axios from "axios";
import { baseURL } from "@/api/axiosConfig";

export default {
  data() {
    return {
      titles: "",
      searchText: "",
      currentPage: 1,
      pageSize: 10,
      allNews: [], // 所有新闻数据
      lastUpdated: "", // 最后更新时间
      scrollPosition: 0, // 保存滚动位置
      savedState: null, // 保存列表状态
      isLoading: false, // 添加加载状态
      belong: null, // 新增 belong 参数
      activeNames: [], // 用于记录当前展开的面板
    };
  },
  computed: {
    // 过滤 + 分页后的新闻列表
    filteredNews() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;

      let filtered = this.allNews;
      if (this.belong) {
        // 根据 belong 参数过滤新闻列表
        filtered = filtered.filter((item) => item.belong === this.belong);
      }

      return filtered
        .filter((item) => {
          const search = this.searchText.toLowerCase();
          return (
            item.title.toLowerCase().includes(search) ||
            item.content.toLowerCase().includes(search)
          );
        })
        .slice(start, end);
    },
    totalItems() {
      return this.filteredNews.length;
    },
  },
  methods: {
    toggle(index) {
      this.allNews[index].isOpen = !this.allNews[index].isOpen;
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    handleSearch() {
      this.currentPage = 1;
    },
    async showDetail(item) {
      // 触发浏览量更新请求
      await this.updateReadingVolume(item);

      // 保存当前状态
      this.scrollPosition =
        window.scrollY || document.documentElement.scrollTop;

      this.savedState = {
        page: this.currentPage,
        search: this.searchText,
        scrollPosition: this.scrollPosition,
      };
      // 导航到详情页时携带状态
      // this.$router.push({
      //   path: `/news/detail/${item.id}`,
      //   query: {
      //     listState: JSON.stringify(this.savedState),
      //   },
      // });
    },
    // 新增方法：更新浏览量并获取内容
    async updateReadingVolume(item) {
      if (item.isOpen) {
        return; // 已经展开过则不再更新
      }

      try {
        console.log("更新浏览量:" + item.id);
        const response = await getNewsDetail(item.id);

        if (response.data.code === 200) {
          item.readingvolume += 1;
          // 关键：将详情内容赋值给 item.content
          if (response.data.data) {
            item.content = response.data.data.content;
            console.log('获取到内容:', item.content);
          }
        } else {
          this.$message.error("获取新闻失败：" + response.data.msg);
        }
      } catch (error) {
        console.error("浏览量更新失败:", error);
      }
    },
    async fetchNewsList() {
      this.isLoading = true;
      try {
        // 将 belong 参数传递到后台接口
        const response = await axios.get(baseURL + "/interface/news/newslist", {
            params: {
              belong: this.belong || '' // 传递 belong 参数，如果为空则传空字符串
            }
          });

        console.log('接口返回数据:', response.data);

        if (response.data.code === 200) {
          // 安全检查：确保数据结构正确
          if (response.data.data && Array.isArray(response.data.data)) {
            // 根据 belong 参数匹配对应的分类
            let targetCategory = null;
            if (this.belong) {
              console.log('查找分类:', this.belong);
              // 查找 title 匹配的分类
              targetCategory = response.data.data.find(
                item => item.title === this.belong
              );
            }
            
            console.log('找到的分类:', targetCategory);
            
            // 如果没有找到匹配的，使用第一个分类
            if (!targetCategory && response.data.data.length > 0) {
              targetCategory = response.data.data[0];
              console.log('使用默认第一个分类:', targetCategory);
            }
            
            if (targetCategory && targetCategory.child && Array.isArray(targetCategory.child)) {
              console.log('目标分类:', targetCategory);
              console.log('child 数据:', targetCategory.child);
              
              this.allNews = targetCategory.child.map((news) => {
                console.log('单个 news 对象:', news);
                return {
                  id: news.id,
                  title: news.title,
                  content: news.content || '', // 初始为空，后续通过详情接口获取
                  date: news.date,
                  hot: news.hot === 1,
                  readingvolume: news.readingvolume,
                  belong: news.belong,
                  hasViewed: false,
                };
              });

              if (this.allNews.length > 0) {
                this.lastUpdated = this.allNews[0].date; // 设置最新时间为第一条发布时间
              }
            } else {
              this.allNews = [];
              this.$message.warning("该分类下暂无问题");
            }
          } else {
            this.allNews = [];
            console.error('数据格式错误:', response.data.data);
          }

          // 检查当前页是否有效
          const totalPages = Math.ceil(this.totalItems / this.pageSize);
          if (this.currentPage > totalPages) {
            this.currentPage = 1;
          }

          // 恢复滚动位置
          this.$nextTick(() => {
            if (this.scrollPosition > 0) {
              window.scrollTo(0, this.scrollPosition);
            }
          });
        } else {
          this.$message.error("获取新闻失败：" + response.data.msg);
        }
      } catch (error) {
        console.error("获取新闻列表失败:", error);
        this.$message.error("请求失败：" + error.message);
      } finally {
        this.isLoading = false;
      }
    },

    handlePageChange() {
      // 滚动到顶部
      window.scrollTo(0, 0);
    },
    truncateContent(content) {
      if (!content) return "";
      return content.length > 100 ? content.substring(0, 100) + "..." : content;
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    // 安全的JSON解析函数
    safeParseJSON(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        console.error("解析JSON失败:", e);
        return null;
      }
    },
  },
  created() {
    // 从路由查询参数中获取 belong 参数
    this.belong = this.$route.query.belong;

    // 从路由查询参数中恢复状态
    if (this.$route.query.listState) {
      try {
        const state = JSON.parse(this.$route.query.listState);
        this.currentPage = state.page || 1;
        this.searchText = state.search || "";
        this.scrollPosition = state.scrollPosition || 0;
      } catch (e) {
        console.error("解析列表状态失败", e);
      }
    }
  },
  mounted() {
    this.fetchNewsList(); // 页面加载时请求新闻数据
  },
  watch: {
    // 监听路由变化，处理返回的状态
    "$route.query": {
      handler(newQuery) {
        this.belong = newQuery.belong; // 更新 belong 参数

        if (newQuery.listState) {
          const state = this.safeParseJSON(newQuery.listState);
          if (state) {
            this.currentPage = state.page || 1;
            this.searchText = state.search || "";
            this.scrollPosition = state.scrollPosition || 0;

            // 确保数据加载后恢复滚动位置
            this.$nextTick(() => {
              if (this.scrollPosition > 0) {
                window.scrollTo(0, this.scrollPosition);
              }
            });
          }
        }
        // ✅ 当 belong 变化时重新获取数据
        this.fetchNewsList();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.news-detail-container {
  max-width: 1200px;
  margin: 40px auto;
  padding: 20px;
}

.detail-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

/* 头部样式优化 */
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.header-left h2 {
  color: #2c5cc5;
  font-size: 24px;
  margin: 0;
}

.back-button {
  background-color: #4c8aff;
  border-color: #4c8aff;
  padding: 15px 15px;
  border-radius: 4px;
  transition: all 0.3s;
}

.back-button:hover {
  background-color: #3a7aff;
  border-color: #3a7aff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(58, 122, 255, 0.3);
}

.detail-list {
  min-height: 650px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  padding: 18px; /* 调整内边距 */
  margin-bottom: 16px; /* 增大项间距 */
  border-radius: 10px; /* 圆润边框 */
  background: #f8f9fa;
  transition: all 0.3s;
  cursor: pointer;
  border-left: 3px solid #1e57e6;
}

.detail-item:hover {
  transform: translateX(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #e6f0ff;
}

.item-main {
  flex: 1;
  margin-right: 20px;
}

.item-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.title-text {
  font-size: 18px;
  color: #1e57e6;
  font-weight: 500;
  margin-left: 4px; /* 标题与左边框间距 */
}

.item-content {
  font-size: 16px;
  color: #606266;
  line-height: 1.7;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 4px;
}

.item-content :deep(p) {
  margin-bottom: 10px;
}

.item-content :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px auto;
}

.item-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 120px;
}

.date {
  color: #909399;
  font-size: 14px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.el-tag--danger {
  background-color: #ff4d4f;
  color: white;
}

/* 加载状态和空状态样式 */
.loading-state,
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.loading-state i,
.empty-state i {
  font-size: 3rem;
  margin-bottom: 15px;
  display: block;
}

.loading-state i {
  color: #4c8aff;
}

.empty-state i {
  opacity: 0.5;
}

/* 内容加载状态 */
.content-loading {
  text-align: center;
  padding: 30px;
  color: #909399;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.content-loading i {
  color: #4c8aff;
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .detail-item {
    flex-direction: column;
    gap: 10px;
  }

  .item-meta {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #eee;
  }
}
</style>
